module.exports = __webpack_public_path__ + "media/images/responsive/costumes/close-8462e83fbfd9fdee08e55b52be4aec6e.png";